import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { IDataLoaderResult } from 'src/app/services/data-loader/data-loader-result';
import { IQueryContext } from 'src/app/services/query-context/models/IQueryContext';
import { IDashboardItem } from 'src/app/utils/dashboard-item';
import { pivotTable } from 'src/app/utils/pivot';

export interface IAlertDataTextDashboardItemOptions extends Omit<
    IDashboardItem,
    'composeData'
> {
    /** Name of the column to get text from */
    columnName: string;
}

@Component({
    selector: 'app-alert-data-text',
    templateUrl: './alert-data-text-dashboard-item.component.html',
    styleUrls: ['./alert-data-text-dashboard-item.component.scss'],
})
export class AlertDataTextDashboardItemComponent implements OnInit {
    @Input()
    dashboardItemOptions!: IAlertDataTextDashboardItemOptions;
    // dashboardItem!: IAlertDataTextDashboardItemOptions;

    @Input()
    dataLoaderEmitter!: EventEmitter<IDataLoaderResult>;

    visible: boolean = false;
    dataText: string = 'Loading...';

    private dataLoaderSubscriber = (dataLoaderResult: IDataLoaderResult) => {
        console.log({
            msg: `[AlertDataTextComponent][${this.dashboardItemOptions.instanceId}] Got dataLoaderResult`,
            dataLoaderResult,
        });

        if (dataLoaderResult.isLoading) {
            this.visible = false;
        } else {
            if (dataLoaderResult.status == 'error') {
                this.dataText = dataLoaderResult.statusMessage;
            } else {
            }
        }

        if (dataLoaderResult.status == 'ok') {
            const data = AlertDataTextDashboardItemComponent.composeData(
                dataLoaderResult.data,
                dataLoaderResult.queryContext
            );
            // get the first row of data
            this.dataText = data[this.dashboardItemOptions.columnName][0];
            this.visible = this.dataText.length > 0;
        }
    };

    ngOnInit(): void {
        this.dataLoaderEmitter.subscribe(this.dataLoaderSubscriber);
    }

    static composeData(data: any[], context?: IQueryContext) {
        const pivotResult = pivotTable<any>(data);
        return pivotResult;
    }
}
